import anime from 'animejs'
import React from 'react'
import { useEffect } from 'react'

export default function Hero() {

    useEffect(() => {
        anime({
            targets: '#breathe',
            opacity: [0, 1],
            duration: 3000,
            easing: 'linear',
            loop: true,
            direction: 'alternate'
        })

        let blob = anime({
            targets: '#blobs path',
            d: [
                /* { value: 'M 60.2019 139.968C 10.0264 141.87 -15.9066 59.2741 10.4905 15.8247C 36.8876 -27.6246 60.2019 30.8118 74.8044 43.5304C 89.4069 56.2491 129.333 5.46655 138.59 26.0864C 147.847 46.7062 110.377 138.065 60.2019 139.968Z' }, */
                { value: 'M 94.7303 124.45C 37.6879 145.918 39.743 147.892 33.2237 112.891C 26.7044 77.8904 -20.0016 75.3768 9.914 28.6733C 39.8296 -18.0302 145.625 -3.39022 139.766 41.766C 133.907 86.9223 151.773 102.983 94.7303 124.45Z' },
                { value: 'M 140 70C 140 108.66 108.66 140 70 140C 31.3401 140 0 108.66 0 70C 0 31.3401 31.3401 0 70 0C 108.66 0 140 31.3401 140 70Z' },
                /* { value: 'M 124.947 96.4905C 189.446 158.421 26.9318 145.985 8.50335 110.278C -9.92511 74.5713 3.08441 68.4983 33.2399 26.0748C 63.3955 -16.3488 145.302 -3.12518 139.397 37.8929C 133.491 78.911 60.4474 34.5605 124.947 96.4905Z' }, */
                /* { value: 'M 120.975 100.634C 174.428 163.517 60.2338 140.583 44.9616 104.327C 29.6894 68.0698 -17.8624 77.2397 7.12832 34.1629C 32.1191 -8.91386 86.1565 -3.77269 129.305 9.32019C 172.454 22.4131 67.5226 37.7501 120.975 100.634Z' } */
            ],
            duration: 10000,
            loop: true,
            easing: 'easeOutQuad',
            direction: 'alternate'
        })

        let popup = anime({
            targets: '#hero',
            opacity: [0.2, 1],
            translateY: [100, 0],
            easing: 'easeInOutSine',
            duration: 2000
        })

        blob.play()
        popup.play();
    }, [])

    return (
        <div id="hero" className="w-11/12 max-w-5xl m-auto relative">
            <div className="flex flex-col justify-center h-screen relative">
                <div className="absolute left-2/3 -translate-x-10 top-1/2 transform -translate-y-1/2 ">
                    <svg id="blobs" width="100%" height="100%" viewBox="0 0 150 150" className="hidden md:flex" fill="#29283D" xmlns="http://www.w3.org/2000/svg">
                        <path d="M 140 70C 140 108.66 108.66 140 70 140C 31.3401 140 0 108.66 0 70C 0 31.3401 31.3401 0 70 0C 108.66 0 140 31.3401 140 70Z" stroke="#29283D" />
                    </svg>
                </div>

                <p className="text-3xl md:text-3xl text-green-300 font-thin font-mono z-10">Hi,</p>
                <p className="text-7xl md:text-9xl text-white-300 font-bold z-10 mt-4">I'm <span className="text-green-500 ">Jintu.</span></p>
                <p className="text-4xl md:text-8xl text-violet-100 font-medium z-10 mt-4">I create experiences <span className="">that</span> <span id="breathe">breathes</span>.</p>
                <div className="flex flex-col md:flex-row md:space-x-4">
                    <p className="text-lg md:text-xl text-black-100 font-mono font-extralight mt-8">Sports Programmer</p>
                    <p className="hidden md:flex items-center text-black-100 mt-8 font-mono text-2xl">
                        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                            <path fill-rule="evenodd" d="M10 3a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5H4a1 1 0 110-2h5V4a1 1 0 011-1z" clip-rule="evenodd" />
                        </svg>
                    </p>
                    <p className="text-lg md:text-xl text-black-100 font-mono font-extralight md:mt-8">Web Developer</p>
                </div>

                <a href="/resume.pdf" target="_blank" rel="noreferrer" className="mr-auto">
                    <button className="mt-8 w-32 text-xl text-green-300 md:text-green-100 p-4 border-2 border-green-300 md:border-green-100 rounded-full hover:text-green-300 hover:border-green-300">Resume</button>
                </a>
            </div>
        </div>
    )
}
